<template>
  <div>
    <topbar
      :titulo="editandoTurma ? $t('ACADEMICO_TURMAS.EDITAR_TURMA') : $t('ACADEMICO_TURMAS.NOVA_TURMA')"
      :subtitulo="editandoTurma ? $t('ACADEMICO_TURMAS.TURMA_DESCRICAO_EDITAR') : $t('ACADEMICO_TURMAS.TURMA_DESCRICAO_NOVO')"
      :breadcrumbs="breadcrumbs"
    >
      <template #header>
        <b-button
          variant="secondary"
          class="mr-2"
          @click="voltar"
        >
          {{ $t('GERAL.VOLTAR') }}
        </b-button>
      </template>
    </topbar>

    <div>
      <div class="d-flex justify-content-between mb-4">
        <div>
          <p class="titulo-medio">Dados de cadastro:</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <input-text
            v-model="form.descricao"
            :label="$t('ACADEMICO.NOME')"
            :placeholder="$t('ACADEMICO.NOME')"
            type="text"
            :maxLength="50"
            ref="nome"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            type="number"
            v-model="form.cargaHoraria"
            :label="$t('ACADEMICO.CARGA_HORARIA')"
            :placeholder="$t('ACADEMICO.CARGA_HORARIA')"
            :min="1"
            :maxLength="6"
            ref="cargaHorariaTurma"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            type="number"
            v-model="form.vagas"
            :label="$t('ACADEMICO.VAGAS')"
            :placeholder="$t('ACADEMICO.VAGAS')"
            :min="1"
            :maxLength="6"
            ref="vaga"
            required
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pt-2 pb-4 d-flex justify-content-end">
        <b-button variant="primary" @click="abrirModal">Adicionar</b-button>
      </div>
      <!-- <tabela-disciplina :items="form.disciplinas" @remover="remover" /> -->
      <b-table
        :items="form.disciplinas"
        :fields="colunasDisciplina"
        show-empty
        :empty-text="$t('GERAL.NENHUM_REGISTRO')"
        head-variant="light"
        responsive
        striped
        hover
        :key="indexTabela"
      >
        <template #cell(acoes)="item">
          <b-dropdown variant="outline-default">
            <b-dropdown-item @click="editarDisciplina(item)">
              {{ $t('GERAL.EDITAR') }}
            </b-dropdown-item>
            <b-dropdown-item @click="removerDisciplina(item)" v-if="podeExcluir">
              {{ $t('GERAL.EXCLUIR') }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div class="d-flex justify-content-end">
      <b-button variant="primary" @click="salvarFormulario">
        {{ $t('GERAL.SALVAR') }}
      </b-button>
    </div>

    <modal-disciplinas
      :exibir="exibirModalDisciplinas"
      :form="form"
      :opcoesDisciplinas="opcoesDisciplinas"
      :opcoesMedia="opcoesMedia"
      :disciplinaSelecionada="disciplinaSelecionada"
      @salvarDisciplina="salvarDisciplina"
      @fechar="fecharModal"
    />

  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import TurmasService from '@/common/services/academico/turma.service.js';
import DisciplinasService from '@/common/services/academico/disciplinas.service.js';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service.js';

// Models:

// Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import { InputText } from '@/components/inputs';
import ModalDisciplinas from './components/ModalDisciplinas.vue';

export default {
  mixins: [Permissoes],
  components: {
    Topbar,
    InputText,
    ModalDisciplinas
  },
  data() {
    return {
      id: this.$route.params.id,
      filtro: this.$route.params.filtro,
      indexTabela: 0,
      refs: [],
      exibirModalDisciplinas: false,
      form: {
        disciplinas: [],
      },
      disciplinaDados: {},
      opcoesDisciplinas: [],
      opcoesMedia: [],
      colunasDisciplina: [
        {
          key: 'codigo',
          label: 'Disciplina',
          sortable: true,
        },
        {
          key: 'disciplinaDescricao',
          label: 'Descrição',
          sortable: true,
        },
        {
          key: 'tipoMediaEnumDescricao',
          label: 'Média',
          sortable: true,
        },
        {
          key: 'cargaHoraria',
          label: 'Carga horária',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      disciplinaSelecionada: {}
    };
  },
  async mounted() {
    if (this.editandoTurma) await this.buscarTurmasPorId();
    await this.getDisciplina();
    await this.getTipoMedia();
  },
  computed: {
    editandoTurma() {
      return !!this.$route.params.id
    },
    anoLetivoId() {
    return this.filtro?.anoLetivoId || this.filtro?.ano_letivo_id || this.filtro?.anoId || null
   },
    breadcrumbs() {
      return [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: this.$t('ACADEMICO.ESTRUTURA_CEJ') },
        { titulo: this.$t('ACADEMICO.TURMAS') },
        { titulo: this.editandoTurma
            ? this.$t('ACADEMICO_TURMAS.EDITAR_TURMA')
            : this.$t('ACADEMICO_TURMAS.NOVA_TURMA')
        },
      ]
    },
    opcoesDisciplinasFormated() {
      return this.opcoesDisciplinas.filter(i => {
        return !this.form.disciplinas.find(disciplina => i.id == disciplina.disciplinaId)
      });
    }
  },
  methods: {
    async buscarTurmasPorId() {
      await TurmasService.buscarPorId(this.id).then(({ data }) => {
        this.form = data;
      })
    },

    abrirModal() {
      this.exibirModalDisciplinas = true;
    },

    async salvarDisciplina(novaDisciplina) {
      if (!this.form.id) {
        this.adicionarDisciplinaLocalmente(novaDisciplina);
        return;
      }

      await this.editarDisciplinaBackend(novaDisciplina);
    },

    editarDisciplinaLocalmente(novaDisciplina) {
      const mediaDescricao = this.opcoesMedia.filter(
        ({ id }) => id === novaDisciplina.tipoMediaEnum
      );

      novaDisciplina.tipoMediaEnumDescricao = mediaDescricao[0].descricao;

      const disciplinaDescricao = this.opcoesDisciplinas.filter(
        ({ id }) => id === novaDisciplina.disciplinaId
      );

      novaDisciplina.disciplinaDescricao = disciplinaDescricao[0].descricao;
      novaDisciplina.codigo = disciplinaDescricao[0].codigo;

      let index = this.form.disciplinas.findIndex(d => d.id === novaDisciplina.id);
      
      if (novaDisciplina.id == null)
        this.form.disciplinas.push(novaDisciplina);
      else
        this.$set(this.form.disciplinas, index, novaDisciplina);
    },

    async editarDisciplinaBackend(novaDisciplina) {
      this.$store.dispatch(START_LOADING);
      this.editarDisciplinaLocalmente(novaDisciplina);

      if (novaDisciplina.id) {
        await DisciplinasService
        .editarTurmaDisciplina({ ...novaDisciplina, turmaId: this.form.id })
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Disciplina criada com sucesso')
          );

          this.getDisciplina();
          this.indexTabela++;
        }).catch((err) => {
          mensagem.showErrors(err);
        }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
      } else {
        await DisciplinasService
        .criarTurmaDisciplina({ ...novaDisciplina, turmaId: this.form.id })
        .then((data) => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Disciplina criada com sucesso')
          );

          this.$set(this.form, 'disciplinas', data.data);

          this.getDisciplina();
          this.indexTabela++;
        }).catch((err) => {
          mensagem.showErrors(err);
        }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
      }     
    },

    adicionarDisciplinaLocalmente(novaDisciplina) {
      const mediaDescricao = this.opcoesMedia.filter(
        ({ id }) => id === novaDisciplina.tipoMediaEnum
      );

      novaDisciplina.tipoMediaEnumDescricao = mediaDescricao[0].descricao;

      const disciplinaDescricao = this.opcoesDisciplinas.filter(
        ({ id }) => id === novaDisciplina.disciplinaId
      );

      novaDisciplina.disciplinaDescricao = disciplinaDescricao[0].descricao;
      novaDisciplina.codigo = disciplinaDescricao[0].codigo;

      if (novaDisciplina.index > -1) 
        this.$set(this.form.disciplinas, novaDisciplina.index, novaDisciplina);
      else 
        this.form.disciplinas.push(novaDisciplina);
      
      this.getDisciplina();
    },

    editarDisciplina(item) {
      this.disciplinaSelecionada = item;
      this.abrirModal();
    },

    removerDisciplina(item) {
      mensagem
        .confirmacao(null, this.$t('Deseja remover disciplina ?'))
        .then(async (result) => {
          if (result.value) {
            if (item.item.id) {
              await this.removerDisciplinaBackend(item);
              return;
            }
            this.form.disciplinas.splice(item.index, 1);
            this.getDisciplina();
          }
        });
    },

    async removerDisciplinaBackend(item) {
      this.$store.dispatch(START_LOADING);
      await DisciplinasService
        .excluirTurmaDisciplina({ id: item.item.id, turmaId: this.form.id })
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Disciplina removida com sucesso')
          );
          this.form.disciplinas.splice(item.index, 1);
          this.getDisciplina();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    async getTipoMedia() {
      this.$store.dispatch(START_LOADING);
      await EnumeradoresService.listar('tipo-media')
        .then(({ data }) => {
          this.opcoesMedia = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));

        }).catch((err) => {
          mensagem.showErrors(err);
        }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    async getDisciplina() {
      this.$store.dispatch(START_LOADING);
      await DisciplinasService.listar()
        .then(({ data }) => {
          this.opcoesDisciplinas = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    // --------------------------------------------------------
    salvarFormulario() {
      if (this.form?.id) return this.atualizarTurma();

      this.form.cursoId = this.filtro.cursoId;
      this.form.grupoTurmaId = this.filtro.grupoTurmaId;
      this.criarTurma();
    },
    criarTurma() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      TurmasService.criar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('ACADEMICO.TURMA_CADASTRADA')
          );
          this.$emit('atualiza-tabela');
          this.$emit('fechar');
        })
        .catch((err) => {
          mensagem.showErrors(err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.$router.push({
            name: 'academico-estrutura-cej-turmas',
            params: {
              filtro: this.filtro 
            },
          });
        });
    },
    atualizarTurma() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      TurmasService.editar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('ACADEMICO.TURMA_EDITADA')
          );
          this.$emit('atualiza-tabela');
          this.$emit('fechar');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.$router.push({
            name: 'academico-estrutura-cej-turmas',
            params: {
              filtro: this.filtro 
            },
          });
        });
    },
    fecharModal() {
      this.novaDisciplina = {
        disciplinaId: '',
        tipoMediaEnum: '',
        cargaHoraria: '',
        id: null
      };
      this.exibirModalDisciplinas = false
    },
    validarFormulario() {
      const totalCargaHoraria = this.form.disciplinas
        .map((disciplina) => parseInt(disciplina.cargaHoraria))
        .reduce((acc, cargaHoraria) => acc + cargaHoraria, 0);
      if (totalCargaHoraria > this.form.cargaHoraria) {
        mensagem.erro(
          this.$t('GERAL.ERRO'),
          this.$t(
            'A soma da Carga Horária das disciplinas está maior que a Carga Horária da turma'
          )
        );
        return;
      }
      return helpers.validarFormulario(this.$refs);
    },

    voltar() {
      this.$router.push({
        name: 'academico-estrutura-cej-turmas',
      })
    },
  },
};
</script>

<style>
.alinhamento-botao {
  padding-top: 28px;
}
</style>
